import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'The ShipSkis Guarantee',
  description:
    'We’re here to make ski travel easier, more reliable, and way ' +
    'less stressful. That’s why every shipment is backed by the ShipSkis guarantee.',
  alternates: {
    canonical: 'https://www.shipskis.com/guarantee',
  },
}

export default metadata
